import ReactGA from 'react-ga4';
import { TRACKING_ID } from './config';

const init = () => ReactGA.initialize(TRACKING_ID);

export default init;
